export const CategoryActionTypes = {
  SET_CATEGORY_LIST: "@@category/SET_CATEGORY_LIST",
};
